import styles from './styles.module.scss';

import React from 'react';
import PropTypes from 'prop-types';
import {isEmpty} from 'lodash';

/**
 *
 * Placeholder
 *
 * @prop tag
 * @prop rows
 * @prop isReady
 * @prop data
 */
class Placeholder extends React.Component {
  static propTypes = {
    tag: PropTypes.string,
    rows: PropTypes.number,
    isReady: PropTypes.bool.isRequired,
    data: PropTypes.any,
    width: PropTypes.string,
  };

  static defaultProps = {
    tag: null,
    rows: 1,
    isReady: false,
    data: null,
    width: '100%',
  };

  get placeholders() {
    const {rows, width} = this.props;

    return (
      <React.Fragment>
        {[...Array(rows)].map((item, index) => {
          const isLast = rows > 1 && rows === index + 1;

          const style = {
            maxWidth: isLast ? '75%' : width,
          };

          return (
            <span
              key={index}
              className={styles['placeholder-row']}
              style={style}
              data-loading={true}
            />
          );
        })}
      </React.Fragment>
    );
  }

  render() {
    const {tag, className, isReady, data, children} = this.props;

    let _children;

    if (isReady) {
      _children = isEmpty(data) ? null : children;
    } else {
      _children = this.placeholders;
    }

    if (isEmpty(tag)) {
      return _children;
    } else {
      return React.createElement(
        tag,
        {
          className: className,
        },
        _children
      );
    }
  }
}

export default Placeholder;
